<template>
  <div
    class="ui-sidebar-nav-item sidebar-item customer-expandable"
    :class="[
      variant ? `sidebar-item--${variant}` : null,
      { active, expandable },
    ]"
    role="button"
    tabindex="0"
    :title="resolvedTitle"
    @click="handleClick"
    @keydown.enter.prevent="handleClick"
    @keydown.space.prevent="handleClick"
  >
    <i :class="icon"></i>
    <span v-if="!sidebarCollapsed">{{ label }}</span>
    <ExpandArrowIcon
      v-if="expandable && !sidebarCollapsed"
      :expanded="expanded"
    />
    <slot />
  </div>
</template>

<script>
import ExpandArrowIcon from './ExpandArrowIcon.vue';

export default {
  name: 'SidebarNavItem',
  components: {
    ExpandArrowIcon,
  },
  props: {
    icon: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    variant: {
      type: String,
      default: '',
    },
    active: {
      type: Boolean,
      default: false,
    },
    expanded: {
      type: Boolean,
      default: false,
    },
    expandable: {
      type: Boolean,
      default: true,
    },
    sidebarCollapsed: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
  },
  emits: ['click'],
  computed: {
    resolvedTitle() {
      if (this.title !== '') return this.title;
      return this.sidebarCollapsed ? this.label : '';
    },
  },
  methods: {
    handleClick(event) {
      this.$emit('click', event);
    },
  },
};
</script>

<style src="../styles/SidebarNavItem.css"></style>
